import { render, staticRenderFns } from "./AddCourseTopic.vue?vue&type=template&id=c6ad548e&scoped=true"
import script from "./AddCourseTopic.vue?vue&type=script&lang=js"
export * from "./AddCourseTopic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ad548e",
  null
  
)

export default component.exports